// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d29c6a82","977":"ebdf8f93"}[chunkId] + ".chunk.js";
};